import { render, staticRenderFns } from "./AdminMailingLists.vue?vue&type=template&id=7b80ba2a&scoped=true"
import script from "./AdminMailingLists.vue?vue&type=script&lang=js"
export * from "./AdminMailingLists.vue?vue&type=script&lang=js"
import style0 from "./AdminMailingLists.vue?vue&type=style&index=0&id=7b80ba2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80ba2a",
  null
  
)

export default component.exports